import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class StyleService {
    updatePageStyle(actionType: string, className: string): void {
        if (actionType === 'add') {
            document.body.classList.add(className);
        } else {
            if (
                actionType === 'remove' &&
                document.body.classList.contains(className)
            ) {
                document.body.classList.remove(className);
            }
        }
    }
}
